<template>
  <sl-side-panel v-model="visible" :mask-closable="false" :title="itemTitle">
    <Form class="sm" ref="form" :model="form" :rules="rules" :label-width="110">
      <FormItem label="机构名称" prop="name">
        <Input v-model="form.name" :maxlength="128"></Input>
      </FormItem>
      <FormItem label="机构编号" prop="code">
        <Input v-model="form.code" :maxlength="64"></Input>
      </FormItem>
      <FormItem label="机构简称" prop="shortName">
        <Input v-model="form.shortName" :maxlength="64"></Input>
      </FormItem>
      <FormItem label="机构类型" prop="type">
        <sl-select v-model="form.type" dict="orgType"></sl-select>
      </FormItem>
      <FormItem label="联系电话" prop="contactPhone">
        <Input v-model="form.contactPhone" :maxlength="16"></Input>
      </FormItem>
      <FormItem label="单位性质" prop="properties">
        <sl-select v-model="form.properties" dict="orgProperty"></sl-select>
      </FormItem>
      <FormItem label="所属级别" prop="level">
        <sl-select v-model="form.level" dict="orgLevel"></sl-select>
      </FormItem>
      <FormItem label="所属区域" prop="districtCode">
        <sl-area :limit="districtLimit" v-model="form.districtCode" :level="3" @change-data="handleAreaChange"/>
      </FormItem>
      <FormItem label="上级监管机构" prop="parentId">
        <sl-select v-model="form.parentId" dict="org" :filterable="true"></sl-select>
      </FormItem>

      <FormItem label="地址" prop="address">
        <Input v-model="form.address" :maxlength="128"></Input>
      </FormItem>
      <FormItem label="是否有效" prop="state">
        <sl-select v-model="form.state" type="radio" dict="$state"></sl-select>
      </FormItem>
      <FormItem label="备注" prop="remark">
        <Input type="textarea" :autosize="{minRows: 5,maxRows: 8}" v-model="form.remark"></Input>
      </FormItem>
      <FormItem>
        <Button :loading="loading" @click="handleSubmit('form')" type="primary">确定</Button>
      </FormItem>
    </Form>
  </sl-side-panel>
</template>
<script>
import { phoneValidator } from '@/util/validator'
import global from '@/util/mixin/global'

export default {
  mixins:[global],
  data() {
    
    return {
      rules: {
        name: [
          { required: true, message: '请输入机构名称', trigger: 'blur,change' },
        ],
        code: [
          { required: true, message: '请输入机构编码', trigger: 'blur,change' },
        ],
        shortName: [
          { required: false, message: '请输入机构简称', trigger: 'blur,change' },
        ],
        contactPhone: [
          { required: true, validator: phoneValidator(), trigger: 'blur,change' },
        ],
        type: [
          { type: 'number', required: true, message: '请选择机构类型', trigger: 'blur,change' },
        ],
        properties: [
          { type: 'number', required: true, message: '请选择单位性质', trigger: 'blur,change' },
        ],
        districtCode: [
          { required: true, message:'请选择区域', trigger: 'blur,change' }
        ],
        parentId:[
           { type: 'number', required: false, message: '请选择上级单位', trigger: 'blur,change' },
        ]
        // code: [
        //   { required: true, message: '请输入社会信用代码号', trigger: 'blur,change' },
        // ],
        // regName: [
        //   { required: true, message: '请输入注册人姓名', trigger: 'blur,change' },
        // ],
        // regIdNo: [
        //   { required: true, message: '请输入注册人身份证号', trigger: 'blur,change' },
        // ],
        // legalName: [
        //   { required: true, message: '请输入法人电话', trigger: 'blur,change' },
        // ],
        // legalMobile: [
        //   { required: true, message: '请输入法人电话', trigger: 'blur,change' },
        // ],
      },
      def: {},
      form: {
        id: null,
        shortName: null,
        name: null,
        contact: null,
        contactPhone: null,
        type: null,
        properties: null,
        code: null,
        state: null,
        address:null,
        districtCode:null,
        remark: null,
        parentId:null,
      },
      id: null,
      area:[],
      loading: false,
      visible: false,
      isCreate: true,
      organizations:[],
    }
  },

  created() {
    this.def = { ...this.form }
    this.$request.organizationFilter('').then(resp => {
      this.organizations = (resp.data || []).map( i => ({value:i.id , label:i.name}))
    })
  },
  computed: {
    itemTitle() {
      return this.id ? '编辑监管机构' : '新增监管机构'
    },
    districtLimit(){
      return this.subject.districtCodes || []
    },
  },
  methods: {
    query() {
      this.$request.organization(this.id).then(resp => {
        this.$utils.fill(this.form, resp.data)
      })
    },

    init(id) {
      this.id = id
      this.visible = true
      this.reset()
      if (this.id) {
        this.query()
      }
    },

    reset() {
      this.$refs['form'].resetFields()
      this.$utils.fill(this.form, this.def)
      this.area = []
    },


    save() {
      //
      let params = { ...this.form }

      this.loading = true

      let promise = this.id ? this.$request.organizationUpdate : this.$request.organizationCreate
      promise(params).then(resp => {
        if (resp.code) {
          this.$Message.error({ content: resp.msg })
        } else {
          this.$Message.success('保存成功')
          this.$emit('on-update')

          if( !this.id ){
            this.visible = false
          }
        }
        this.loading = false
      })

    },

    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.save()
        } else {
          this.$Message.error('参数错误');
        }
      })
    },
    handleAreaChange(data){
      this.$utils.areaSet(this.form , data.map(i => i.name))
    },
    handleClose() {
      this.$emit('on-update')
    }
  }
}

</script>
